export namespace S25Map {
    export function copyMap<Key, Value>(map: ReadonlyMap<Key, Value>): Map<Key, Value>;
    export function copyMap<Key, Value, Result>(
        map: ReadonlyMap<Key, Value>,
        transform: (value: Value, key: Key) => Result,
    ): Map<Key, Result>;
    export function copyMap<Key, Value, Result = Value>(
        map: ReadonlyMap<Key, Value>,
        transform?: (value: Value, key: Key) => Result,
    ): Map<Key, Result> {
        const copied = new Map<Key, Result>();
        for (const [key, value] of map) {
            copied.set(key, transform ? transform(value, key) : (value as unknown as Result));
        }
        return copied;
    }
}
